import store from './store'
import update from './update'
import relateModules from './relateModules'
import relateGroups from './relateGroups'

const namespaced = true

export default {
  namespaced,
  modules: {
    store,
    update,
    relateModules,
    relateGroups
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/members/forms/index.js